import { Action } from 'redux';
import { put, select } from '@redux-saga/core/effects';

import { AppState, ErrorAction } from 'store';
import { BasketSagaReturnType } from 'store/sagaHelpers';
import { BasketActions, BasketActionTypes, BasketLoadingItem } from 'store/basket';
import { userHelper, analyticsHelper, errorToBasketErrorModel } from 'helpers';
import { api } from 'repositories/api';
import { BasketItemModel, ProductTypes, BasketDetailsModel, SOFASHIELD } from 'models/Basket';

const DEFAULT_SOFASHIELD_COUNT = 0;

export interface RemoveAllSofashieldsAction extends Action<BasketActionTypes.REMOVE_ALL_SOFASHIELDS> {
    loadingItems: BasketLoadingItem[];
}

export interface RemoveAllSofashieldsActionStart extends Action<BasketActionTypes.REMOVE_ALL_SOFASHIELDS_START> {
    loadingItems: BasketLoadingItem[];
}

export interface RemoveAllSofashieldsActionSuccess extends Action<BasketActionTypes.REMOVE_ALL_SOFASHIELDS_SUCCESS> {
}

export interface RemoveAllSofashieldsActionError extends ErrorAction<BasketActionTypes.REMOVE_ALL_SOFASHIELDS_ERROR> {
}
export function* removeAllSofashieldsQueueSaga({ loadingItems }: RemoveAllSofashieldsAction): BasketSagaReturnType {
    yield put<BasketActions>({
        type: BasketActionTypes.REMOVE_ALL_SOFASHIELDS_START,
        loadingItems
    });

    try {
        let state: AppState = yield select();
        const removingSofashieldItems = state.basketState.basket!.entries.filter((entry: BasketItemModel) =>
            loadingItems.some(item => item.id === entry.product.code));
        const removedSofashieldQuantity = removingSofashieldItems.sum((entry: BasketItemModel) => entry.sofashieldQuantity);

        for (let index = 0; index < removingSofashieldItems.length; index++) {
            let entryItem = removingSofashieldItems[index];
            if (entryItem.entryNumber !== undefined) {
                yield api.hybris.updateSofashieldQuantity(
                    userHelper.getCurrentUserName(),
                    state.basketState.basket!.guid,
                    entryItem.entryNumber,
                    entryItem.quantity,
                    DEFAULT_SOFASHIELD_COUNT
                );
            }
        }

        const sofashieldItem = state.basketState.basket!.entries.find(e => e.product.name === SOFASHIELD);

        state = yield select();
        const basket = state.basketState.basket!;

        sendAnalytics(sofashieldItem?.product.code ?? SOFASHIELD, removedSofashieldQuantity, sofashieldItem, basket);

        yield put<BasketActions>({
            type: BasketActionTypes.REMOVE_ALL_SOFASHIELDS_SUCCESS
        });

        return true;
    } catch (error) {
        yield put<BasketActions>({
            type: BasketActionTypes.REMOVE_ALL_SOFASHIELDS_ERROR,
            error: errorToBasketErrorModel(error, 'removeAllSofashieldsQueueSaga')
        });

        return false;
    }
}

function sendAnalytics(code: string, removedQuantity: number, sofashieldItem: BasketItemModel | undefined, updatedBasket: BasketDetailsModel): void {
    analyticsHelper.withLogging(() => {
        api.google.removeAdditionalProduct(ProductTypes.Sofashield, code, removedQuantity);
        api.exponea.removeFromCart(updatedBasket, sofashieldItem!, removedQuantity);
    }, 'removeAllSofashieldsQueueSaga');
}